<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs12
      >
        <CustomerHeader :customer="customer" />
      </v-flex>

      <v-flex
        xs12
        md8
      >
        <CustomerProfile :customer="customer" />
        <CustomerPassword :customer="customer" />
        <CustomerOrders
          :items="customer.orders"
          class="mb-4"
          @create-order="$router.push({ name: 'draft-order', params: { customer: customer.id}})"
        />
      </v-flex>
      <v-flex
        xs12
        md4
      >
        <CustomerSubscriptions
          :customer="customer"
          @change="$emit('subscription-change')"
        />
        <CustomerAddressWidget
          :customer="customer"
        />
        <CustomerGroup
          :customer="customer"
          class="mb-4"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerAddressWidget from './CustomerAddressWidget'
import CustomerSubscriptions from './CustomerSubscribtions'
import CustomerProfile from './CustomerProfile'
import CustomerPassword from './CustomerPassword'
import CustomerOrders from './CustomerOrders'
import CustomerHeader from './CustomerHeader'
import CustomerGroup from './CustomerGroup'
import LoadingState from '@/components/LoadingState'

export {
  CustomerAddressWidget,
  CustomerSubscriptions,
  CustomerProfile,
  CustomerOrders,
  CustomerHeader,
  CustomerGroup
}

export default {
  name: 'CustomerSingle',

  components: {
    LoadingState,
    CustomerAddressWidget,
    CustomerSubscriptions,
    CustomerProfile,
    CustomerPassword,
    CustomerOrders,
    CustomerHeader,
    CustomerGroup
  },

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  computed: {
    loading () {
      return Object.entries(this.customer).length === 0
    },

    title () {
      return (
        this.customer && `${this.customer.firstname} ${this.customer.lastname}`
      )
    },

    disabled () {
      return this.customer.inProgress || !this.customer.isChanged
    }
  }
}
</script>
